import React from 'react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_kuldeep-skin/artifacts/ywrbpmj5_logo8.png";

export default function DivyadeepLogo({ size = 'md', variant = 'color' }) {
  const sizes = {
    sm: { img: 'h-8', text: 'text-[10px]', sub: 'text-[7px]' },
    md: { img: 'h-10', text: 'text-xs', sub: 'text-[8px]' },
    lg: { img: 'h-14', text: 'text-sm', sub: 'text-[9px]' },
  };
  const s = sizes[size] || sizes.md;
  const isLight = variant === 'light';

  return (
    <div className="flex items-center gap-2.5" data-testid="divyadeep-logo">
      <img
        src={LOGO_URL}
        alt="Divyadeep Clinic - Best Dermatologist in Jhansi"
        className={`${s.img} w-auto object-contain flex-shrink-0`}
      />
      <div className="hidden sm:block">
        <p className={`font-outfit font-medium ${s.text} tracking-tight leading-tight ${isLight ? 'text-white' : 'text-[#0F172A]'}`}>
          Divyadeep Skin
        </p>
        <p className={`${s.sub} leading-tight ${isLight ? 'text-white/50' : 'text-[#475569]'}`}>
          Laser & Hair Transplant Center
        </p>
      </div>
    </div>
  );
}
